import { Component, OnInit, Input } from '@angular/core';
import { IConsultaRegistroVentas } from '../interfaces/ConsultaRegistroVentas';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { RegistroVentasService } from '../Services/registro-ventas.service';
import { ToastrService } from 'ngx-toastr';
import { formatDate } from '@angular/common';
import { IRegistroVentasValores } from '../interfaces/RegistroVentaValores';



@Component({
  selector: 'app-consultaregistro',
  templateUrl: './consultaregistro.component.html',
  styleUrls: ['./consultaregistro.component.css']
})
export class ConsultaregistroComponent implements OnInit {
  formConsulta: FormGroup;
  formatDate: string;
  valorSeleccion=true;
  selectedwithTax!:boolean

  @Input() ItemConsulta: IConsultaRegistroVentas;
  @Input() CategotiasBaresComidas: string[];

  hiperMercado : string = '14'
  valorVenta!:string
 
  constructor( private readonly formBuilder: FormBuilder,
   private readonly registroServicios: RegistroVentasService, 
   private toaster: ToastrService) {
    
   }

  ngOnInit(): void {
    this.valorSeleccion = this.ItemConsulta['fueAbierto'];
    this.selectedwithTax = this.ItemConsulta.datosRegistroVentas[2].tieneImpuesto != null ? this.ItemConsulta.datosRegistroVentas[2].tieneImpuesto :false
    this.valorVenta = this.getValue();
    this.construirFromularioConsulta();
    this.formConsulta.get('fechaValorRegistrado').setValue(this.ItemConsulta['fechaValorRegistrado']);

    this.changeApertura()
  }

   construirFromularioConsulta() {
    this.formConsulta = this.formBuilder.group({
      ventas: ['', Validators.required],
      valorSinCalcular: ['', Validators.required],
      tieneImpuesto: ['', Validators.required],
      facturas: ['', Validators.required],
      productos: ['', Validators.required],
      trafico: ['', Validators.required],
      presupuesto:['', Validators.required],
      fechaValorRegistrado:['', Validators.required],
      idDatoRegistroV:[''],
      idDatoRegistroF:[''],
      idDatoRegistroP:[''],
      idDatoRegistroT:[''],
      idDatoRegistroPr:[''],
      idRegistro:[''],
      fueAbierto:[''],
    });
  }

  actualizarRegistroVentas() {
    this.formConsulta.value.valorSinCalcular = this.formConsulta.value.ventas
    if (this.CategotiasBaresComidas.includes(this.ItemConsulta.categoria)) {
          this.formConsulta.value.ventas = this.aplicarImpuesto(this.formConsulta.value.valorSinCalcular,0.08);
        } else {
          this.formConsulta.value.ventas = this.aplicarImpuesto(this.formConsulta.value.valorSinCalcular,0.19);
        }

    
    this.formConsulta.value.tieneImpuesto = this.selectedwithTax

    if(this.valorSeleccion == false)
    {
        this.registroServicios.actualizarRegistroVentas(this.formConsulta.value)
        .subscribe(e => {
          this.toaster.success('Pactia Ventas', 'Se ha actualizado con éxito!.');
        });
   
      
    }else{
      if(this.formConsulta.controls['ventas'].value == ''){
        this.toaster.warning('Campo ventas', 'Para continuar con el registro es necesario ingresar el.');
      }
      else if(this.formConsulta.controls['facturas'].value == ''){
        this.toaster.warning('Campo facturas', 'Para continuar con el registro es necesario ingresar el.');
      }
     
      else{
        this.registroServicios.actualizarRegistroVentas(this.formConsulta.value)
        .subscribe(e => {
          this.toaster.success('Pactia Ventas', 'Se ha actualizado con éxito!.');
        });
      }
    }
     
  }
  error:any={isError:false,errorMessage:''};
  compareTwoDates(){
    this.formatDate = formatDate(this.formConsulta.controls['fechaValorRegistrado'].value, 'yyyy/MM/dd', 'en-US');
    if(new Date(this.formatDate) > new Date()){
       this.error={isError:true,errorMessage: 'La fecha no puede ser mayor al dia actual'};
    }
    else{
     this.error={isError:false,errorMessage: ''};
    }
 }

 numberOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return false;
  }
  return true;
}
opciones = [
  { id: true, name: 'Si hubo apertura' },
  { id: false, name: 'No hubo apertura' }
];

  validarCampos(){
    if(this.valorSeleccion == false) {
      this.formConsulta.get('ventas').setValue('');
      this.formConsulta.get('facturas').setValue('');
      this.formConsulta.get('productos').setValue('');
      this.formConsulta.get('trafico').setValue('');
      this.formConsulta.get('presupuesto').setValue('');
      
    }
  }
  changeApertura()
  {
    if (this.valorSeleccion == false) {
      this.formConsulta.get('ventas').disable();
      this.formConsulta.get('facturas').disable();
      this.formConsulta.get('productos').disable();
      this.formConsulta.get('trafico').disable();

    }else{
      this.formConsulta.get('ventas').enable();
      this.formConsulta.get('facturas').enable();
      this.formConsulta.get('productos').enable();
      this.formConsulta.get('trafico').enable();

    }
  }

  optionsTax(type:boolean):string{
    if(this.CategotiasBaresComidas.includes(this.ItemConsulta.categoria)){
      if(type){
        return "Sin Impoconsumo"
      }
      return "Con Impoconsumo"
    }else{
      if(type){
        return "sin iva"
      }
      return "con iva"
    }
  }

  getValue():string{
    return this.ItemConsulta.datosRegistroVentas[2].valorSinCalcular != null ? 
    this.ItemConsulta.datosRegistroVentas[2].valorSinCalcular : this.ItemConsulta.datosRegistroVentas[2].valor
  }

  private aplicarImpuesto(value: string, impuesto: number): string {
    let ventasNumber: number = parseFloat(value) || 0;

    return Math.floor(
        this.selectedwithTax 
            ? ventasNumber 
            : ventasNumber - (ventasNumber * impuesto)
    ).toString();
  }

  getRegistros(tipoRegistro:string): IRegistroVentasValores{
    switch (tipoRegistro) {
      case 'Facturas':
        return this.ItemConsulta.datosRegistroVentas.find(x => x.idCampo === 1)
      case 'Productos':
        return this.ItemConsulta.datosRegistroVentas.find(x => x.idCampo === 2)
      case 'Ventas':
        return this.ItemConsulta.datosRegistroVentas.find(x => x.idCampo === 3)
      case 'Trafico':
        return this.ItemConsulta.datosRegistroVentas.find(x => x.idCampo === 4)
      case 'Presupuesto':
        return this.ItemConsulta.datosRegistroVentas.find(x => x.idCampo === 5)
    }
  }

}

